import { OBLIGATION_STATUS_META } from "../lib/obligations";
import type { ObligationStatus } from "../lib/obligations";

/**
 * Штамп статуса обязательства (Прил. Б ТЗ) + признак эскалации.
 *
 * КОРОТКИЕ подписи для узких колонок — принятое отступление дизайна Д-5 (docs/07 §6): полное
 * «ОЖИДАЕТ СОБЫТИЯ» ломает колонку реестра, где на строку приходится несколько сантиметров.
 * В карточке договора остаётся полная подпись — там место есть.
 *
 * Оформление — только токенами статусов из docs/07 (правило 9).
 */

/** Короткие варианты подписей для таблиц (Д-5). Отличаются только там, где полная не влезает. */
const SHORT_LABELS: Partial<Record<ObligationStatus, string>> = {
  awaiting: "Ожидает",
  control: "Контроль",
  fulfilled: "Исполнено",
};

export function StatusStamp({
  status,
  escalated = false,
  short = false,
}: {
  status: ObligationStatus;
  escalated?: boolean;
  /** Узкая колонка реестра: короткая подпись (Д-5). Полное наименование — в подсказке. */
  short?: boolean;
}) {
  const meta = OBLIGATION_STATUS_META[status];
  const label = short ? (SHORT_LABELS[status] ?? meta.label) : meta.label;
  return (
    <span className="inline-flex flex-wrap items-center gap-1">
      {/* title держит ПОЛНОЕ наименование: сокращение не должно скрывать термин ТЗ. */}
      <span className={`stamp ${meta.cls}`} title={label === meta.label ? undefined : meta.label}>
        {label}
      </span>
      {escalated && (
        <span
          className="stamp bg-overdue-bg text-overdue-fg"
          title="Просрочка больше порога — сигнал директору и юристу (Прил. В ТЗ)"
        >
          {short ? "!" : "Эскалация"}
        </span>
      )}
    </span>
  );
}
